import React, { useState } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { ThemeContext } from "./ThemeContext";
import theme from "../theme";

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);
  
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <ChakraProvider value={theme}>
      <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
        {children}
      </ThemeContext.Provider>
    </ChakraProvider>
  );
};
